/* Pearl Hanger — About Us: scroll-reveal, safe for multiple instances + theme editor */
(function () {
  function initReveal(root) {
    var els = root.querySelectorAll('.about-us__reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAll() {
    document.querySelectorAll('.about-us[data-section-id]').forEach(initReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.about-us');
    if (root) initReveal(root);
  });
})();
